import {Component, ViewEncapsulation} from '@angular/core';
/**
 * \@title Sidenav with a FAB
 */
export class SidenavFabExample {static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sidenav-fab-example',
  templateUrl: 'sidenav-fab-example.html',
  styleUrls: ['sidenav-fab-example.css'],
  encapsulation: ViewEncapsulation.None,
  preserveWhitespaces: false,
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function SidenavFabExample_tsickle_Closure_declarations() {
/** @type {?} */
SidenavFabExample.decorators;
/**
 * @nocollapse
 * @type {?}
 */
SidenavFabExample.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
